import { createAction, props } from '@ngrx/store';
import { LoginResult } from './../../../app/@shared/models/login_result.model';
import { HttpErrorResponse } from '@angular/common/http';

export const actionPrefix = '[auth]';

export const noSessionFound = createAction(actionPrefix + ' No Session Found');

export const login = createAction(actionPrefix + ' Login', props<{
  data: {
    email: string;
    password: string;
    otp: undefined;
    force_login: boolean;
  }
}>());
export const loginSuccess = createAction(actionPrefix + ' Login Success', props<{ data: LoginResult }>());
export const loginFailure = createAction(actionPrefix + ' Login Failure', props<{ error: HttpErrorResponse }>());

export const logout = createAction(actionPrefix + ' Logout');
export const logoutSuccess = createAction(actionPrefix + ' Logout Success');
export const logoutFailure = createAction(actionPrefix + ' Logout Failure', props<{ error: HttpErrorResponse }>());

export const validateAuth = createAction(actionPrefix + ' Validate Auth', props<{
  data: {
    user_uuid: string;
    token: string;
  }
}>());
export const reValidateAuth = createAction(actionPrefix + ' Revalidate Auth');
export const validateAuthSuccess = createAction(actionPrefix + ' Validate Auth Success', props<{
  data: {
    user_uuid: string;
    token: string;
  }
}>());
export const validateAuthFailure = createAction(actionPrefix + ' Validate Auth Failure', props<{ error: HttpErrorResponse }>());
